export default "__VITE_ASSET__4a28f687__"